import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DropdownRender } from '../../../components/DropdownRender';

export const OrganizationTypesSelect = () => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const organizationTypes = useSelector((state) => state.reportSummaryDictionaries.organizationTypes);
  const orgTypeIds = Form.useWatch('orgTypeIds', form);

  const options = organizationTypes.map((item) => ({
    label: item.nameRu,
    value: item.id,
  }));

  const allIds = organizationTypes.map((item) => item.id);

  const handleSelectAll = () => {
    const shouldSelectAll = !orgTypeIds || orgTypeIds.length !== allIds.length;
    form.setFieldsValue({ orgTypeIds: shouldSelectAll ? allIds : [] });
  };

  return (
    <Form.Item
      name='orgTypeIds'
      rules={[{ required: true, message: t('error.requiredField') }]}
    >
      <Select
        placeholder={t('governmentServiceEducation.organizationType')}
        maxTagCount='responsive'
        options={options}
        mode='multiple'
        style={{ minWidth: 150 }}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        optionFilterProp='label'
        dropdownRender={(menu) => (
          <DropdownRender
            menu={menu}
            handleSelectAll={handleSelectAll}
            formIds={orgTypeIds}
            dictionaryIds={allIds}
          />
        )}
      />
    </Form.Item>
  );
};
